module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Author’s Note and Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_vm._v("The 1815 Campaign")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter02"
    }
  }, [_vm._v("The Divisional System")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter03"
    }
  }, [_vm._v("Sir Thomas Picton")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The British Infantry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Brussels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Assembly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quatre Bras")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Withdrawal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waterloo")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reputations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Appendices",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0